import { createPropertyMetadataDecorator, META_PERMISSIONS_MAP } from '@actiris/bff';
import { Action, Resource } from './permissions-constants';

const Permission = (action: Action, resource: Resource, isAllowedByDefault = true) =>
    createPropertyMetadataDecorator(META_PERMISSIONS_MAP, (action: Action, resource: Resource, isAllowedByDefault: boolean) => ({
        resource,
        action,
        isAllowedByDefault,
    }))(action, resource, isAllowedByDefault);

export class AppPermissions {
    /**
     * Give access to the profile feature where the user can edit his profile
     * This one is authorized by default. Meaning that the absence of the claim will authorize the user.
     */
    @Permission('View', 'Profile')
    readonly canViewProfile!: boolean;

    /**
     * Give access to the access request feature where the user can ask for some specific access for himself or for someone else.
     */
    @Permission('Create', 'AccessRequest', false)
    readonly canCreateAccessRequest!: boolean;

    /**
     * Allow the user to edit his contact email.
     * This one should disappear in the future as it won't be managed inside the token anymore.
     */
    @Permission('Edit', 'ContactEmail')
    readonly canEditContactEmail!: boolean;
}
